import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {
    authActions,
    DetailValue,
    formatDate,
    formatDateTime,
    HorizontalLoader,
    Icon,
    Loader,
    localUTCToDateTime,
    modal,
    ModalActions,
    subjektFormatter,
    utils,
} from "@mc/mc-legacy";
import {
    Alert,
    Button,
    ButtonGroup,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container, DropdownItem, DropdownMenu, DropdownToggle,
    Row,
    UncontrolledDropdown
} from "reactstrap";
import * as ProfileActions from "../actions/ProfileActions";
import * as ChangePasswordResult from "../api/gen/core/ChangePasswordResult";
import * as TypDokladuInfo from "../api/TypDokladuInfo";
import * as TypAutentizace from "mc/lib/api/gen/ucty/v1/TypAutentizace";
import * as TypAutentizaceInfo from "../api/TypAutentizaceInfo";
import * as StavUctu from "mc/lib/api/gen/ucty/v1/StavUctu";
import AktivaceUctuForm from "../components/profile/AktivaceUctuForm";
import SpravaUctuApi from "../api/gen/core/SpravaUctuApi";
import UserProfileApi from "../api/gen/core/UserProfileApi";
import ConfigApi from "../api/gen/core/ConfigApi";
import ChangePasswordForm from "../components/form/ChangePasswordForm";
import {toastr} from "react-redux-toastr";
import {SubmissionError} from "redux-form";
import SpravaKontaktuApi from "../api/gen/core/SpravaKontaktuApi";
import {i18n} from "../i18n/i18n";
import SubmitOnlyForm from "../components/form/SubmitOnlyForm";
import {withLang} from "../i18n/withLang";
import GetKontaktForm from "../components/profile/GetKontaktForm";
import OverKontaktForm from "../components/profile/OverKontaktForm";
import EditKontaktForm from "../components/profile/EditKontaktForm";
import IcoInputForm from "../components/form/IcoForm";
import FoInputForm from "../components/form/FoForm";
import AddChildForm from "../components/profile/AddChildForm";
import "./ProfilePage.scss";
import {dialogSubmit} from "../components/form/utils";

enum TypExternichDat {
    CEKA = "CEKA",
    NACTENO = "NACTENO",
    NEDOSTUPNE = "NEDOSTUPNE",
}

/**
 * Odeslání zprávy o odstranění účtu.
 */
const sendAccountDeleteMessage = () => {
    const parentWindow = window.parent;

    if (parentWindow) {
        const sendObj = {
            type: "account-delete",
            result: "OK",
        };
        console.log(sendObj);
        parentWindow.postMessage(sendObj, window.location.origin);
    }
};

const ZpusobyPrihlaseniPanel = ({
                                    typExternichDat,
                                    userProfileLoginList,
                                    posledniUspesnaPrihlaseni,
                                    onPortalRedirect,
                                    lang
                                }) => {
    return (
        <Card className="border-0 mb-4">
            <CardHeader className={"pb-0"}>
                <Row>
                    <Col>
                        <h2>{i18n(lang, "ProfilePage_loginTypes")}</h2>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody className="pt-2 pb-0">
                {userProfileLoginList.rows.map((autentizace, key) => {
                    let logPrihlaseni = posledniUspesnaPrihlaseni.find(
                        (l) => l.typAutentizace === autentizace.typAutentizace && l.login === autentizace.login
                    );
                    return (
                        <AutentizaceInfo
                            autentizace={autentizace}
                            key={key}
                            onPortalRedirect={onPortalRedirect}
                            typExternichDat={typExternichDat}
                            logPrihlaseni={logPrihlaseni}
                            lang={lang}
                        />
                    );
                })}
            </CardBody>
        </Card>
    );
};

const DataBlock = ({
                       children,
                       label,
                       className,
                       ...other
                   }: React.PropsWithChildren<{
    label: string;
    className?: string
} & React.ComponentProps<typeof Col>>) => {
    return (
        <Col xs={12} sm={4} className={"pb-2" + (className ? " " + className : "")} {...other}>
            <DetailValue label={label}>{children}</DetailValue>
        </Col>
    );
};

export enum TypNotifikace {
    EMAIL = "EMAIL",
    TELEFON = "TELEFON",
    HROMADNE_OSLOVENI = "HROMADNE_OSLOVENI",
}

class NotifikaceComponent extends React.Component<any> {
    renderOvereniInfo = (overen) => {
        return overen ?
            <Col xs={4} className="text-right notifikace-icon notifikace-icon-active">
                <Icon icon={"check-circle-o"} /> {i18n(this.props.lang, "ProfilePage_notificationEnabled")}
            </Col> : <Col xs={4} className="text-right notifikace-icon notifikace-icon-inactive">
                <Icon icon={"times-circle-o"} /> {i18n(this.props.lang, "ProfilePage_notificationDisabled")}
            </Col>
    }

    showOvereni = (typ, kontakt, finishedCallback) => {
        const {onChange, dispatch} = this.props;

        dispatch(
            ModalActions.show(OverKontaktForm, {
                typ,
                kontakt,
                // onSubmit: () => {},
                onSubmitSuccess: () => {
                    dispatch(modal.ModalActions.hide());
                    finishedCallback();
                    onChange();
                }
            }, "", {
                size: "lg",
                noHeader: true
            })
        );
    }

    handleZapnout = (typ, kontakt, overeno) => {
        const {dispatch, onChange} = this.props;

        if (!overeno) {
            this.handleEdit(typ, kontakt)
        } else {
            let api;
            switch (typ) {
                case TypNotifikace.EMAIL:
                    api = SpravaKontaktuApi.enableNotifikaceEmail();
                    break;
                case TypNotifikace.TELEFON:
                    api = SpravaKontaktuApi.enableNotifikaceTelefon();
                    break;
                case TypNotifikace.HROMADNE_OSLOVENI:
                    api = SpravaKontaktuApi.enableHromadneOsloveni();
                    break;
            }

            dispatch(ModalActions.showAsyncWaiting(
                "",
                <div style={{minWidth: 320}}>
                    <div className={"pb-2"}>{i18n(this.props.lang, "WaitingMessage")}</div>
                    <HorizontalLoader />
                </div>,
                api,
                onChange
            ))
        }
    }

    handleVypnout = (typ) => {
        const {dispatch, onChange} = this.props;

        let api;
        switch (typ) {
            case TypNotifikace.EMAIL:
                api = SpravaKontaktuApi.disableNotifikaceEmail();
                break;
            case TypNotifikace.TELEFON:
                api = SpravaKontaktuApi.disableNotifikaceTelefon();
                break;
            case TypNotifikace.HROMADNE_OSLOVENI:
                api = SpravaKontaktuApi.disableHromadneOsloveni();
                break;
        }

        dispatch(ModalActions.showAsyncWaiting(
            "",
            <div style={{minWidth: 320}}>
                <div className={"pb-2"}>{i18n(this.props.lang, "WaitingMessage")}</div>
                <HorizontalLoader />
            </div>,
            api,
            onChange
        ))
    }

    handleEdit = (typ, kontakt) => {
        const {dispatch} = this.props;

        dispatch(
            ModalActions.show(GetKontaktForm, {
                typ,
                initialValues: {kontakt},
                onSubmit: (data) => {
                    return data;
                },
                onSubmitSuccess: (data) => {
                    this.showOvereni(typ, data.kontakt, () => {
                        dispatch(modal.ModalActions.hide());
                    })
                }
            }, "", {
                size: "lg",
                noHeader: true
            })
        );
    }

    renderPanel = (typ, notifikaceZapnuto, kontakt, overeno, disabled, disabledReason) => {
        let label;
        switch (typ) {
            case TypNotifikace.EMAIL:
            case TypNotifikace.TELEFON:
            case TypNotifikace.HROMADNE_OSLOVENI:
                label = i18n(this.props.lang, `TypNotifikace_${typ}`)
                break
        }

        const actionsCommon = {
            title: disabledReason,
            disabled
        }

        return <Col xs={12}>
            <Card className="border-0 mb-4 pb-2">
                <CardHeader className={"pb-0"}>
                    <Row noGutters>
                        <Col xs={8} className="d-flex align-items-center">
                            <h2 className={"mb-0"} style={{wordBreak: "break-word"}}>{label}</h2>
                        </Col>
                        {this.renderOvereniInfo(notifikaceZapnuto)}
                    </Row>
                </CardHeader>
                <CardBody className="py-2">
                    {kontakt && typ != TypNotifikace.HROMADNE_OSLOVENI && <div className={"pb-2"}>{kontakt}</div>}
                    {kontakt && typ == TypNotifikace.HROMADNE_OSLOVENI && <a className={"pb-2"} href={kontakt} target='_blank' >{i18n(this.props.lang, `MoreInformation`)}</a>}
                    <div className={"buttons-actions pt-2"}>
                        {!notifikaceZapnuto && <Button {...actionsCommon} color="primary"
                                                       onClick={() => this.handleZapnout(typ, kontakt, overeno)}>{i18n(this.props.lang, "ProfilePage_notificationEnable")}</Button>}
                        {notifikaceZapnuto && <Button {...actionsCommon} color="primary" outline
                                                      onClick={() => this.handleVypnout(typ)}>{i18n(this.props.lang, "ProfilePage_notificationDisable")}</Button>}
                        {kontakt && typ != TypNotifikace.HROMADNE_OSLOVENI && <Button {...actionsCommon} color="primary" outline
                                            onClick={() => this.handleEdit(typ, kontakt)}>{i18n(this.props.lang, "ProfilePage_notificationChange")}</Button>}
                    </div>
                </CardBody>
            </Card>
        </Col>
    }

    render() {
        const {detail, typExternichDat} = this.props;

        const actionTitle =
            typExternichDat === TypExternichDat.NEDOSTUPNE ? i18n(this.props.lang, "ProfilePage_actionInaccessible") : "";


        const items = [];
        if (detail.overovatEmail) {
            items.push(this.renderPanel(TypNotifikace.EMAIL, detail.emailNotifikace, detail.email, detail.emailOveren, typExternichDat === TypExternichDat.NEDOSTUPNE, actionTitle));
        }
        if (detail.overovatTelefon) {
            items.push(this.renderPanel(TypNotifikace.TELEFON, detail.telefonNotifikace, detail.telefon, detail.telefonOveren, typExternichDat === TypExternichDat.NEDOSTUPNE, actionTitle));
        }
        if (detail.zapnuteHO) {
            items.push(this.renderPanel(TypNotifikace.HROMADNE_OSLOVENI, detail.hoSouhlas, detail.urlPodminkyHO, true, typExternichDat === TypExternichDat.NEDOSTUPNE, actionTitle));
        }

        return <Row>{items}</Row>
    }
}

class ZakladniUdajeComponent extends React.Component<any> {

    handleOffEdit = (typ, kontakt) => {
        const {dispatch, onChange} = this.props;

        let api;
        let name;
        switch (typ) {
            case TypNotifikace.EMAIL:
                api = SpravaKontaktuApi.updateEmail;
                name = "email"
                break;
            case TypNotifikace.TELEFON:
                api = SpravaKontaktuApi.updateTelefon;
                name = "telefon"
                break;
        }

        dispatch(
            ModalActions.show(EditKontaktForm, {
                typ,
                initialValues: {[name]: kontakt},
                onSubmit: (data) => {
                    return api({kontakt: data[name]}).then(() => {
                        onChange()
                        dispatch(ModalActions.hide());
                    })
                },
                // onSubmitSuccess: (data, dispatch) => {},
            }, "", {
                size: "lg",
                noHeader: true
            })
        );
    }

    showSouhlasDetail = (souhlas) => {
        const souhlasDetail = () => (
            <div
                style={{
                    padding: "1rem",
                }}
            >
                {souhlas.textSouhlas ? <div dangerouslySetInnerHTML={{__html: souhlas.textSouhlas}} />  : ""}
            </div>
        );

        this.props.dispatch(
            ModalActions.show(souhlasDetail, {}, i18n(this.props.lang, `TypSouhlasu_${souhlas.typ}`), {
                size: "lg",
            })
        );
    };

    redirectToConsentPage = () => {
        window.open((window as any).appConfig.serverContextPath + "/redirect/consents", "_blank")
    }

    render() {
        const {externalDetail, detail} = this.props;
        const {data} = detail;
        const nazevProfilu = data.nazev;
        const externiData = externalDetail.data || {};
        const actionTitle = !externalDetail.data ? i18n(this.props.lang, "ProfilePage_actionInaccessible") : "";

        return (
            <Card className="border-0 mb-4">
                <CardHeader className={"pb-0"}>
                    <Row noGutters>
                        <Col xs={6} className="d-flex align-items-center">
                            <h2 className={"mb-0"}>{i18n(this.props.lang, "ProfilePage_baseTitle")}</h2>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody className="py-2">
                    <Row key="nacionale">
                        <DataBlock xs={12} sm={3} label={i18n(this.props.lang, "ProfilePage_baseJmenoPrijmeni")}>
                            {nazevProfilu}
                        </DataBlock>
                        <DataBlock xs={12} sm={3} label={i18n(this.props.lang, "ProfilePage_baseDatumNarozeni")}>
                            {formatDate(externiData.datumNarozeni)}
                        </DataBlock>
                        <DataBlock xs={12} sm={6} label={i18n(this.props.lang, "ProfilePage_baseAdresa")}>
                            {externiData.adresa && subjektFormatter.getAdresa(externiData.adresa)}
                        </DataBlock>
                    </Row>
                    <Row key="kontakt">
                        <DataBlock
                            xs={12}
                            sm={3}
                            label={externiData.typDokladu ? TypDokladuInfo.label(externiData.typDokladu) : i18n(this.props.lang, "ProfilePage_baseDoklad")}
                        >
                            {externiData.typDokladu && externiData.cisloDokladu}
                        </DataBlock>
                        <DataBlock xs={12} sm={3} label={data.overovatTelefon ? i18n(this.props.lang, "ProfilePage_baseTelefon") :
                            <div>
                                {i18n(this.props.lang, "ProfilePage_baseTelefon")}
                                <Button style={{boxShadow: "none", fontSize: "16px", backgroundColor: "transparent"}}
                                        className="border-0 ml-2 btn-secondary p-0"
                                        onClick={() => this.handleOffEdit(TypNotifikace.TELEFON, data.telefon)}
                                        disabled={!externalDetail.data}
                                        aria-label={i18n(this.props.lang, "ProfilePage_baseTelefonEdit")}
                                        title={actionTitle}>
                                    <Icon icon={"pencil"} />
                                </Button>
                            </div>
                        }>
                            {data.telefon}
                        </DataBlock>
                        <DataBlock label={data.overovatEmail ? i18n(this.props.lang, "ProfilePage_baseEmail") :
                            <div>
                                {i18n(this.props.lang, "ProfilePage_baseEmail")}
                                <Button style={{boxShadow: "none", fontSize: "16px", backgroundColor: "transparent"}}
                                        className="border-0 ml-2 btn-secondary p-0"
                                        onClick={() => this.handleOffEdit(TypNotifikace.EMAIL, data.email)}
                                        disabled={!externalDetail.data}
                                        aria-label={i18n(this.props.lang, "ProfilePage_baseEmailEdit")}
                                        title={actionTitle}>
                                    <Icon icon={"pencil"} />
                                </Button>
                            </div>
                        }>
                            {data.email}
                        </DataBlock>
                    </Row>
                    <Row className="souhlasy">
                        <DataBlock label={i18n(this.props.lang, "ProfilePage_baseSouhlasy")} xs={12} sm={12}>
                            {data.souhlasy.map((souhlas, i) => (
                                <Row key={`souhlas-${i}}`}>
                                    <Col xs={12} sm={6}>
                                        {souhlas.typ === 'REG_PODMINKY_GDPR_PORTAL_PAGE'
                                            ?
                                            <Button className="text-left" color="link" onClick={() => this.redirectToConsentPage()}>
                                                {i18n(this.props.lang, `TypSouhlasu_${souhlas.typ}`)}
                                            </Button>
                                            : souhlas.url
                                            ?
                                            <Button className="text-left" color="link" onClick={() => window.open(souhlas.textSouhlas, '_blank')}>
                                                {i18n(this.props.lang, `TypSouhlasu_${souhlas.typ}`)}
                                            </Button>
                                            :
                                            <Button className="text-left" color="link" onClick={() => this.showSouhlasDetail(souhlas)}>
                                                {i18n(this.props.lang, `TypSouhlasu_${souhlas.typ}`)}
                                            </Button>
                                        }
                                    </Col>
                                    <Col xs={12} sm={6}>
                                        {formatDateTime(localUTCToDateTime(souhlas.datumUdeleni))}
                                    </Col>
                                </Row>
                            ))}
                        </DataBlock>
                    </Row>
                </CardBody>
            </Card>
        );
    }
}

const ZakladniUdajePanel = withLang(connect()(ZakladniUdajeComponent));

const NotifikacePanel = withLang(connect()(NotifikaceComponent));

class AutentizaceInfoComponent extends React.Component<any> {
    handleChangePassword = (autentizace) => {
        const formProps = {
            onSubmit: (data) => {
                // Async validace - chceme až na tlačítko submit, proto je zde
                if (data.newPassword !== data.newPassword_repeat) {
                    throw new SubmissionError({
                        _error: i18n(this.props.lang, "Form_HeslaNeshoduji"),
                    });
                }

                // we want to unite error visualitions -> we do not want ErrorApi
                return SpravaUctuApi.changePassword({
                    login: autentizace.login,
                    oldPassword: data.oldPassword,
                    newPassword: data.newPassword
                });
            },
            onSubmitSuccess: (data, dispatch) => {
                dispatch(ModalActions.hide());
                switch (data) {
                    case ChangePasswordResult.REDIRECT_PORTAL:
                        this.props.dispatch(
                            ModalActions.show(
                                SubmitOnlyForm,
                                {
                                    handleSubmit: () => {
                                        if (this.props?.onPortalRedirect) {
                                            this.props?.onPortalRedirect();
                                        }
                                        window.location.reload();
                                    },
                                    message: i18n(this.props.lang, "ProfilePage_passwordChangeNoNewAttempts"),
                                    submitText: "Ok",
                                },
                                i18n(this.props.lang, "ProfilePage_passwordChangeNoNewAttemptsTitle"),
                                {}
                            )
                        );
                        break;
                    case ChangePasswordResult.OK:
                        toastr.success(i18n(this.props.lang, "ProfilePage_passwordChanged"));
                        break;
                }
            }
        };
        const caption = i18n(this.props.lang, "ProfilePage_passwordChangeDialogTitle");
        this.props.dispatch(
            ModalActions.show(ChangePasswordForm, formProps, caption, {
                size: "lg",
            })
        );
    };
    renderAutentizaceAction = (typ, autentizace, typExternichDat) => {
        const actionTitle =
            typExternichDat === TypExternichDat.NEDOSTUPNE ? i18n(this.props.lang, "ProfilePage_actionInaccessible") : "";

        switch (typ) {
            case TypAutentizace.JMENO_HESLO:
                return (
                    <Button
                        color="primary"
                        outline
                        disabled={typExternichDat !== TypExternichDat.NACTENO}
                        onClick={() => this.handleChangePassword(autentizace)}
                        className="mb-2"
                        title={actionTitle}
                    >
                        {i18n(this.props.lang, "ProfilePage_changePassword")}
                    </Button>
                );

            case TypAutentizace.NIA:
            case TypAutentizace.MOJE_ID:
            case TypAutentizace.ISDS:
                return null;

            default:
                return null;
        }
    };

    render() {
        const {
            autentizace,
            autentizace: {typAutentizace, datumZalozeni},
            logPrihlaseni,
            typExternichDat,
        } = this.props;
        let typCaption;

        if (datumZalozeni) {
            switch (typAutentizace) {
                case TypAutentizace.JMENO_HESLO:
                    typCaption = i18n(this.props.lang, TypAutentizaceInfo.getCaption(typAutentizace), autentizace.login);
                    break;

                default:
                    typCaption = i18n(this.props.lang, TypAutentizaceInfo.getCaption(typAutentizace));
                    break;
            }
        } else {
            typCaption = i18n(this.props.lang, TypAutentizaceInfo.getNepripojenoCaption(typAutentizace));
        }

        return (
            <Row className="mb-2">
                <Col xs={12} sm={8}>
                    <Row>
                        <DataBlock xs={12} sm={6} label={i18n(this.props.lang, 'ProfilePage_loginType')}>
                            {typCaption}
                        </DataBlock>
                        <DataBlock xs={12} sm={3} label={i18n(this.props.lang, 'ProfilePage_loginRegistered')}>
                            {datumZalozeni && formatDate(datumZalozeni)}
                        </DataBlock>
                        <DataBlock xs={12} sm={3} label={i18n(this.props.lang, 'ProfilePage_loginLastLogin')}>
                            {logPrihlaseni && formatDate(logPrihlaseni.datumPrihlaseni)}
                        </DataBlock>
                    </Row>
                </Col>
                <Col className={"text-left text-sm-right"} xs={12} sm={4}>
                    {datumZalozeni && this.renderAutentizaceAction(typAutentizace, autentizace, typExternichDat)}
                </Col>
            </Row>
        );
    }
}

const AutentizaceInfo = withLang(connect()(AutentizaceInfoComponent));

const PristupneSubjektyPanel = ({
                                    userId,
                                    subjektyRows,
                                    // children,
                                    dispatch,
                                    lang,
                                    typExternichDat
                                }: React.PropsWithChildren<{ userId: number; lang: string; subjektyRows: any[], dispatch }>) => {

    const [actions, setActions] = useState();

    useEffect(() => {
        ConfigApi.getProfileActions().then(res => {
            if (res) {
                setActions(res);
            }
        });
    }, []);

    const actionTitle = typExternichDat === TypExternichDat.NEDOSTUPNE ? i18n(lang, "ProfilePage_actionInaccessible") : "";

    return (
        <Card className="border-0 mb-4">
            <CardHeader className={"pb-0"}>
                <Row>
                    <Col md={10}>
                        <h2>{i18n(lang, "ProfilePage_pristupyLabel")}</h2>
                    </Col>
                    <Col className="d-flex justify-content-end" md={2}>
                        {actions && (actions.profileAddChildren || actions.profileAddSelfEmployed || actions.profileAddPerson) &&
                            <ButtonGroup>
                                <UncontrolledDropdown>
                                    <DropdownToggle color="primary" outline caret
                                                    disabled={typExternichDat !== TypExternichDat.NACTENO}
                                                    title={actionTitle}>
                                        {i18n(lang, "ProfilePage_pristupyAdd")}
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        {actions.profileAddChildren &&
                                            <DropdownItem onClick={() => handlePridatVazbuNaDeti(userId, dispatch, lang)}>
                                                {i18n(lang, "ProfilePage_pristupyAddDeti")}
                                            </DropdownItem>}
                                        {actions.profileAddSelfEmployed &&
                                            <DropdownItem onClick={() => handlePridatOSVCVazbu(userId, dispatch, lang)}>
                                                {i18n(lang, "ProfilePage_pristupyAddOsvc")}
                                            </DropdownItem>}
                                        {actions.profileAddPerson &&
                                            <DropdownItem onClick={() => handlePridatNaFO(userId, dispatch, lang)}>
                                                {i18n(lang, "ProfilePage_pristupyPerson")}
                                            </DropdownItem>}
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </ButtonGroup>}
                    </Col>
                </Row>
            </CardHeader>
            <CardBody className="pt-2 pb-4">
                {subjektyRows.pristupy ? // mám přístupy z PBO
                    subjektyRows.pristupy.map((data, key) => (
                        <Card key={key} className="mt-4 border-0" color="white" body>
                            <SubjektBlock vlastniSubjektGUID={null} subjektData={data} key={key} dispatch={dispatch}
                                          typExternichDat={typExternichDat} lang={lang} />
                        </Card>
                    )) : // přístupy z EOSP
                    subjektyRows.map((data, key) => (
                        <Card key={key} className="mt-4 border-0" color="white" body>
                            <SubjektBlock vlastniSubjektGUID={null} subjektData={data} key={key} dispatch={dispatch}
                                          typExternichDat={typExternichDat} lang={lang} />
                        </Card>
                    ))
                }
            </CardBody>
            {subjektyRows.pristupyOstatnich && subjektyRows.pristupyOstatnich.length > 0 &&
                <div>
                    <CardHeader className={"pb-0"}>
                        <Row>
                            <Col md={10}>
                                <h2>Osoby, které mají přístup k mým datům</h2>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody className="pt-2 pb-4">
                        {subjektyRows.pristupyOstatnich.map((data, key) => (
                            <Card key={key} className="mt-4 border-0" color="white" body>
                                <SubjektBlock vlastniSubjektGUID={subjektyRows.subjektGuid} subjektData={data} key={key}
                                              dispatch={dispatch} typExternichDat={typExternichDat} lang={lang} />
                            </Card>))}
                    </CardBody>
                </div>
            }
            {subjektyRows.zadosti && subjektyRows.zadosti.length > 0 &&
                <div>
                    <CardHeader className={"pb-0"}>
                        <Row>
                            <Col md={10}>
                                <h2>Odeslané žádosti</h2>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody className="pt-2 pb-4">
                        {subjektyRows.zadosti.map((data, key) => (
                            <Card key={key} className="mt-4 border-0" color="white" body>
                                <ZadostiBlock userId={userId} subjektData={data} key={key} dispatch={dispatch}
                                              typExternichDat={typExternichDat} vlastni={true}
                                              lang={lang}
                                />
                            </Card>
                        ))}
                    </CardBody>
                </div>
            }
            {subjektyRows.zadostiOstatnich && subjektyRows.zadostiOstatnich.length > 0 &&
                <div>
                    <CardHeader className={"pb-0"}>
                        <Row>
                            <Col md={10}>
                                <h2>Příchozí žádosti</h2>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody className="pt-2 pb-4">
                        {subjektyRows.zadostiOstatnich.map((data, key) => (
                            <Card key={key} className="mt-4 border-0" color="white" body>
                                <ZadostiBlock userId={userId} subjektData={data} key={key} dispatch={dispatch}
                                              typExternichDat={typExternichDat} vlastni={false}
                                              lang={lang}
                                />
                            </Card>
                        ))}
                    </CardBody>
                </div>
            }
        </Card>
    );
};

/**
 * Promazání cache s údaji o účtu.
 */
const sendAccountRefreshMessage = () => {
    const parentWindow = window.parent;

    if (parentWindow) {
        const sendObj = {
            type: "account-refresh",
            result: "OK",
        };
        console.log(sendObj);
        parentWindow.postMessage(sendObj, window.location.origin);
    }
};

const handlePridatVazbuNaDeti = (userId, dispatch, lang) => {
    dispatch(
        ModalActions.show(AddChildForm, {
            initialValues: {},
            onSubmit: (data) => {
                const submitData = {
                    jmeno: data.jmeno,
                    prijmeni: data.prijmeni,
                    datumNarozeni: data.datumNarozeni,
                    adresaRegistrId: data.adresa.registrId,
                }

                return dialogSubmit(dispatch, lang, UserProfileApi.addChildrenToProfile(userId, submitData), () => {
                    dispatch(ModalActions.hide());
                    sendAccountRefreshMessage();
                    window.location.reload();
                })
            },
            // onSubmitSuccess: (data, dispatch) => {},
        }, "", {
            size: "xl",
            noHeader: true,
            className: "dialog-add-space-for-address"
        })
    );
}

const handlePridatOSVCVazbu = (userId, dispatch, lang) => {
    dispatch(
        ModalActions.show(
            IcoInputForm,
            {
                onSubmit: (data) => {
                    return dialogSubmit(dispatch, lang, UserProfileApi.addSelfEmployedToProfile(userId, data.ico), () => {
                        dispatch(ModalActions.hide());
                        sendAccountRefreshMessage();
                        window.location.reload();
                    })
                },
            },
            "",
            {
                noHeader: true,
            }
        )
    );
};

const handlePridatNaFO = (userId, dispatch, lang) => {
    dispatch(
        ModalActions.show(
            FoInputForm,
            {
                onSubmit: (data) => {
                    let submitData = {
                        oboustranne: data.oboustranne,
                        jmeno: data.jmeno,
                        prijmeni: data.prijmeni,
                        datumNarozeni: data.datumNarozeni,
                        email: data.email
                    };

                    return dialogSubmit(dispatch, lang, UserProfileApi.addPersonToProfile(userId, submitData), () => {
                        dispatch(ModalActions.hide());
                        sendAccountRefreshMessage();
                        window.location.reload();
                    })
                },
            },
            "",
            {
                size: "xl",
                noHeader: true
            }
        )
    );
};

const handleOdstranitPristup = (userId, subjektGuid, dispatch, lang) => {
    dispatch(
        ModalActions.show(
            SubmitOnlyForm,
            {
                handleSubmit: () => {
                    return dialogSubmit(dispatch, lang, SpravaUctuApi.removePristup(userId, subjektGuid), () => {
                        dispatch(ModalActions.hide());
                        sendAccountRefreshMessage();
                        window.location.reload();
                    })
                },
                message: i18n(lang, "ProfilePage_pristupy_deleteQuestion"),
                submitText: i18n(lang, "ProfilePage_pristupy_delete"),
                dialogTitle: i18n(lang, "ProfilePage_pristupy_deleteTitle"),
            },
            "",
            {
                noHeader: true
            }
        )
    );
};

const SubjektBlock = ({vlastniSubjektGUID, subjektData, dispatch, typExternichDat, lang}) => {
    const actionTitle = typExternichDat === TypExternichDat.NEDOSTUPNE ? i18n(lang, "ProfilePage_actionInaccessible") : "";
    const sbjGuid = vlastniSubjektGUID ? vlastniSubjektGUID : subjektData.subjektGuid; // pokud je předán GUID, jedná se o vazbu k mému subjektu
    return (
        <Row>
            <Col>
                <Row key="sub-1">
                    <Col className={"pb-3"} xs={12} sm={4} md={8}>
                        <strong>
                            {subjektData.subjektNazev}
                            <br />
                        </strong>
                        {(subjektData.subjektAdresa && subjektFormatter.getAdresa(subjektData.subjektAdresa)) || "-"}
                    </Col>
                    {subjektData.typVazby && <DataBlock label={i18n(lang, "ProfilePage_pristupyTypVazby")} md={4}>
                        {i18n(lang, `TypVazbyInfo_${subjektData.typVazby}`)}
                    </DataBlock>}
                </Row>
                <Row key="sub-2">
                    <DataBlock label={i18n(lang, "ProfilePage_pristupyDatumZadosti")} md={4}>
                        {subjektData.datumZadost ? formatDate(subjektData.datumZadost) : i18n(lang, "ProfilePage_pristupyDatumZadostiBez")}
                    </DataBlock>
                    <DataBlock label={i18n(lang, "ProfilePage_pristupyTyp")} md={3}>
                        {subjektData.oboustranne ? i18n(lang, "ProfilePage_pristupyTypOboustranny") : i18n(lang, "ProfilePage_pristupyTypJednostranny")}
                    </DataBlock>
                    <DataBlock label={i18n(lang, "ProfilePage_pristupyEmail")} md={3}>
                        {subjektData.email}
                    </DataBlock>
                </Row>
            </Col>
            <Col className="d-flex justify-content-end border-0" md={1}>
                <Button
                    className="border-0"
                    onClick={() => handleOdstranitPristup(subjektData.ucetGuid, sbjGuid, dispatch, lang)}
                    disabled={typExternichDat !== TypExternichDat.NACTENO}
                    aria-label={i18n(lang, "ProfilePage_pristupy_delete")}
                    title={actionTitle}>
                    <Icon icon={"trash"} />
                </Button>
            </Col>
        </Row>
    );
};

const handleResolveZadost = (userId, zadostId, authorize, dispatch, lang) => {
    const actionTitle = authorize ? i18n(lang, "ProfilePage_pristupy_zadostPrijmout") : i18n(lang, "ProfilePage_pristupy_zadostZamitnout");
    const actionText = authorize ? i18n(lang, "ProfilePage_pristupy_zadostPrijmout") : i18n(lang, "ProfilePage_pristupy_zadostZamitnout");
    dispatch(
        ModalActions.show(
            SubmitOnlyForm,
            {
                handleSubmit: () => {
                    return dialogSubmit(dispatch, lang, UserProfileApi.resolveAccessRequest(userId, zadostId, authorize), () => {
                        dispatch(ModalActions.hide());
                        sendAccountRefreshMessage();
                        window.location.reload();
                    })
                },
                message: i18n(lang, "ProfilePage_pristupy_zadostQuestion", actionText),
                submitText: actionTitle,
                dialogTitle: authorize ? i18n(lang, "ProfilePage_pristupy_zadostTitleAccept") : i18n(lang, "ProfilePage_pristupy_zadostTitleReject"),
            },
            "",
            {
                noHeader: true
            }
        )
    );
};

const handleStornoZadost = (userId, zadostId, dispatch, lang) => {
    dispatch(
        ModalActions.show(
            SubmitOnlyForm,
            {
                handleSubmit: () => {
                    return dialogSubmit(dispatch, lang, UserProfileApi.stornoAccessRequest(userId, zadostId), () => {
                        dispatch(ModalActions.hide());
                        sendAccountRefreshMessage();
                        window.location.reload();
                    })
                },
                message: i18n(lang, "ProfilePage_pristupy_zadostStornoQuestion"),
                submitText: i18n(lang, "ProfilePage_pristupy_zadostStorno"),
                dialogTitle: i18n(lang, "ProfilePage_pristupy_zadostStornoTitle")
            },
            "",
            {
                noHeader: true
            }
        )
    );
};

const ZadostiBlock = ({userId, subjektData, dispatch, typExternichDat, vlastni, lang}) => {
    const actionTitle = typExternichDat === TypExternichDat.NEDOSTUPNE ? "Akce není z důvodů prováděné údržby aktuálně dostupná." : "";

    return (
        <Row>
            <Col>
                <Row key="sub-1">
                    <Col className={"pb-3"} xs={12} sm={4} md={8}>
                        <strong>
                            {subjektData.subjektNazev}
                        </strong>
                    </Col>
                </Row>
                <Row key="sub-2">
                    <DataBlock label={i18n(lang, "ProfilePage_pristupy_zadostDatumVyprseni")} md={4}>
                        {formatDate(subjektData.datumZadost)}
                    </DataBlock>
                    <DataBlock label={i18n(lang, "ProfilePage_pristupyTyp")} md={3}>
                        {subjektData.oboustranne ? i18n(lang, "ProfilePage_pristupyTypOboustranny") : i18n(lang, "ProfilePage_pristupyTypJednostranny")}
                    </DataBlock>
                    <DataBlock label={i18n(lang, "ProfilePage_pristupyEmail")} md={3}>
                        {subjektData.email}
                    </DataBlock>
                </Row>
            </Col>
            <Col className={"text-left text-sm-right"} xs={12} sm={4}>

                {vlastni ? <Button
                        color="primary"
                        outline
                        disabled={typExternichDat !== TypExternichDat.NACTENO}
                        onClick={() => handleStornoZadost(userId, subjektData.zadostId, dispatch, lang)}
                        className="mb-2"
                        style={{marginTop: 30}}
                        title={actionTitle}
                    >
                        {i18n(lang, "ProfilePage_pristupy_zadostStorno")}
                    </Button> :
                    <div>
                        <Button
                            color="primary"
                            outline
                            disabled={typExternichDat !== TypExternichDat.NACTENO}
                            onClick={() => handleResolveZadost(userId, subjektData.zadostId, false, dispatch, lang)}
                            className="mb-2"
                            style={{marginTop: 30}}
                            title={actionTitle}
                        >
                            <Icon icon={"close"} /> {i18n(lang, "ProfilePage_pristupy_zadostZamitnout")}
                        </Button>
                        <Button
                            color="primary"
                            disabled={typExternichDat !== TypExternichDat.NACTENO}
                            onClick={() => handleResolveZadost(userId, subjektData.zadostId, true, dispatch, lang)}
                            className="ml-3 mb-2"
                            style={{marginTop: 30}}
                            title={actionTitle}
                        >
                            <Icon icon={"check"} /> {i18n(lang, "ProfilePage_pristupy_zadostPrijmout")}
                        </Button>
                    </div>}
            </Col>
        </Row>
    );
};

class AktivaceUctuComponent extends React.Component<any> {
    handleSubmit = (kodAktivace) => {
        const {userProfileDetail} = this.props;
        const userId = userProfileDetail.data.userId;
        return SpravaUctuApi.aktivovatUcet(userId, {kodAktivace: kodAktivace.code});
    };
    handleSubmitSuccess = () => {
        const {onActivate} = this.props;
        toastr.success(i18n(this.props.lang, "ProfilePage_ucetAktivovan"));
        onActivate();
    };

    render() {
        return (
            <div>
                <Card className="border-0 mb-4">
                    <CardHeader className={"pb-0"}>
                        <Row>
                            <Col>
                                <h4>{i18n(this.props.lang, "ProfilePage_ucetAktivace")}</h4>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <AktivaceUctuForm onSubmit={this.handleSubmit} onSubmitSuccess={this.handleSubmitSuccess} />
                    </CardBody>
                </Card>
            </div>
        );
    }
}

const AktivaceUctu = withLang(connect()(AktivaceUctuComponent));

const ProfilUzivatele = ({typExternichDat, onExternalDetailChange, stavUctu, onActivate, onPortalRedirect, props}) => {
    const {
        userProfileDetail,
        userProfileLoginList,
        userProfileExternalDetail,
        userProfileSubjektExternalList,
        userProfileSubjektList,
        dispatch
    } = props;
    let subjektyRows = !userProfileSubjektExternalList.fetched
        ? userProfileSubjektList.rows
        : userProfileSubjektExternalList.rows;
    return (
        <div>
            {stavUctu === StavUctu.CEKA_NA_AKTIVACI && (
                <AktivaceUctu userProfileDetail={userProfileDetail} onActivate={onActivate} />
            )}
            {typExternichDat === TypExternichDat.NEDOSTUPNE && (
                <Alert color="warning" className="pl-4 pr-4" style={{paddingTop: 12, paddingBottom: 12}}>
                    {i18n(props.lang, "ProfilePage_dataInaccessible")}
                </Alert>
            )}
            {userProfileDetail.data?.zobrazitNastaveniNotifikaci && (
                <Alert color="danger" className="pl-4 pr-4" style={{paddingTop: 12, paddingBottom: 12}}>
                    {i18n(props.lang, "ProfilePage_notificationReminder")}
                </Alert>
            )}

            <NotifikacePanel
                typExternichDat={typExternichDat}
                detail={userProfileDetail.data}
                onChange={onExternalDetailChange}
            />

            <ZakladniUdajePanel
                typExternichDat={typExternichDat}
                detail={userProfileDetail}
                externalDetail={userProfileExternalDetail}
                onChange={onExternalDetailChange}
            />
            <ZpusobyPrihlaseniPanel
                onPortalRedirect={onPortalRedirect}
                typExternichDat={typExternichDat}
                userProfileLoginList={userProfileLoginList}
                posledniUspesnaPrihlaseni={
                    userProfileExternalDetail.data ? userProfileExternalDetail.data.posledniUspesnaPrihlaseni : []
                }
                lang={props.lang}
            />
            {stavUctu === StavUctu.AKTIVOVANY && !userProfileDetail.data.popRezim && (
                <PristupneSubjektyPanel
                    userId={userProfileDetail.data.userId}
                    subjektyRows={subjektyRows}
                    dispatch={dispatch}
                    typExternichDat={typExternichDat}
                    lang={props.lang}
                />
            )}
        </div>
    );
};

class ProfilePage extends React.Component<any> {
    constructor(props) {
        super(props);

        this.state = {
            fetchUserProfileExternalCount: 0,
        };
    }

    componentDidMount() {
        this.fetchData(this.props);
        this.fetchUserProfileExternal(this.props);
        this.fetchSubjektListExternal(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.fetchData(nextProps);
    }

    fetchUserProfileExternal(props) {
        const key = props.authInfo.data.login;
        console.log("fetching external profile data");
        UserProfileApi.getUserProfileExternal(key).then((data) => {
            this.setState({
                fetchUserProfileExternalCount: this.state.fetchUserProfileExternalCount + 1,
            });
            if (!data) {
                window.setTimeout(() => this.fetchUserProfileExternal(props), 30000);
            } else {
                props.dispatch(ProfileActions.setUserProfileExternalDetail(key, data));
            }
        });
    }

    fetchSubjektListExternal(props) {
        const key = props.authInfo.data.login;
        console.log("fetching external subjekt list data");
        UserProfileApi.getSubjektListExternal(key).then((data) => {
            if (!data) {
                window.setTimeout(() => this.fetchSubjektListExternal(props), 30000);
            } else {
                props.dispatch(ProfileActions.setSubjektListExternal(key, data));
            }
        });
    }

    fetchData = (props) => {
        if (!props.authInfo.fetched) {
            return;
        }

        const key = props.authInfo.data.login;
        props.dispatch(ProfileActions.fetchUserProfileDetailIfNeeded(key));
        props.dispatch(ProfileActions.fetchLoginListIfNeeded(key));
        props.dispatch(ProfileActions.fetchSubjektListIfNeeded(key));
    };
    handleExternalDetailChange = () => {
        this.props.dispatch(ProfileActions.invalidateUserProfileDetail());
        this.fetchUserProfileExternal(this.props);
    };

    /**
     * Odeslani zpravy nadrazenemu oknu o uspesne aktivaci.
     */
    sendAccountActivationMessage = () => {
        const parentWindow = window.parent;

        if (parentWindow) {
            const sendObj = {
                type: "account-activation",
                result: "OK",
            };
            console.log(sendObj);
            parentWindow.postMessage(sendObj, window.location.origin);
        }
    };

    /**
     * Po aktivaci účtu - refresh dat.
     */
    handleActivate = () => {
        this.props.dispatch(ProfileActions.invalidateUserProfileDetail());
        this.fetchUserProfileExternal(this.props);
        this.fetchSubjektListExternal(this.props);
        this.sendAccountActivationMessage();
    };

    handleTrvaleOdstranit = (userId, existujeViceSubjektu) => {
        const {dispatch} = this.props;

        dispatch(
            ModalActions.show(
                SubmitOnlyForm,
                {
                    handleSubmit: () => {
                        return dialogSubmit(dispatch, this.props.lang, UserProfileApi.deleteUcet(userId), () => {
                            dispatch(ModalActions.hide());

                            console.log("succesfully removed user");
                            sendAccountDeleteMessage(); // pokud je v iframe, měl by portál vně eosp iframe zavřít, takže následující dialog by se neměl ani zobrazit

                            // ---
                            dispatch(
                                ModalActions.showInfo(i18n(this.props.lang, "ProfilePage_ucetDeleteSuccessTitle"), i18n(this.props.lang, "ProfilePage_ucetDeleteSuccessMessage"), () => {
                                    dispatch(ModalActions.hide());
                                    window.location.reload();
                                })
                            );
                        })
                    },
                    message: existujeViceSubjektu ? i18n(this.props.lang, "ProfilePage_ucetDeleteQuestion1") : i18n(this.props.lang, "ProfilePage_ucetDeleteQuestion2"),
                    submitText: i18n(this.props.lang, "ProfilePage_ucetDeleteAction"),
                    dialogTitle: i18n(this.props.lang, "ProfilePage_ucetDeleteTitle")
                },
                "",
                {
                    noHeader: true
                }
            )
        );
    };

    render() {
        const {
            userProfileExternalDetail,
            userProfileDetail,
            userProfileLoginList,
            userProfileSubjektList,
            userProfileSubjektExternalList
        } = this.props;
        const {fetchUserProfileExternalCount} = this.state;

        if (!(userProfileDetail.data && userProfileLoginList.rows && userProfileSubjektList.rows)) {
            return <Loader />;
        }

        const stavUctu = userProfileDetail.data.stavUctu;

        const typExternichDat: TypExternichDat =
            fetchUserProfileExternalCount === 0
                ? TypExternichDat.CEKA
                : userProfileExternalDetail.data
                    ? TypExternichDat.NACTENO
                    : TypExternichDat.NEDOSTUPNE;

        const actionTitle =
            typExternichDat === TypExternichDat.NEDOSTUPNE ? i18n(this.props.lang, "ProfilePage_actionInaccessible") : "";

        let subjektyRows = !userProfileSubjektExternalList.fetched
            ? userProfileSubjektList.rows
            : userProfileSubjektExternalList.rows;

        let existujeViceSubjektu = false;
        if (subjektyRows.pristupy && subjektyRows.pristupy.length > 0) {
            existujeViceSubjektu = true;
        }

        return (
            <div className={"overflow-hidden profile-page " + (window as any).brandConfig.theme}>
                <Container fluid className={"px-0"}>
                    <ProfilUzivatele
                        onPortalRedirect={() => {
                            sendAccountDeleteMessage();
                        }}
                        typExternichDat={typExternichDat}
                        props={this.props}
                        stavUctu={stavUctu}
                        onExternalDetailChange={this.handleExternalDetailChange}
                        onActivate={this.handleActivate}
                    />
                    {!userProfileDetail.data.popRezim &&
                        <Button className={"mb-4"} id={"at-delete-account"} color={"primary"} outline
                                onClick={() => this.handleTrvaleOdstranit(userProfileDetail.data.userId, existujeViceSubjektu)}
                                title={actionTitle} disabled={typExternichDat !== TypExternichDat.NACTENO}>
                            {i18n(this.props.lang, "ProfilePage_ucetDelete")}
                        </Button>}
                </Container>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        authInfo: utils.storeFromArea(state, authActions.AUTH_INFO_AREA),
        userProfileDetail: utils.storeFromArea(state, ProfileActions.USER_PROFILE_DETAIL_AREA),
        userProfileExternalDetail: utils.storeFromArea(state, ProfileActions.USER_PROFILE_EXTERNAL_DETAIL_AREA),
        userProfileLoginList: utils.storeFromArea(state, ProfileActions.USER_PROFILE_LOGIN_LIST_AREA),
        userProfileSubjektList: utils.storeFromArea(state, ProfileActions.USER_PROFILE_SUBJEKT_DETAIL_AREA),
        userProfileSubjektExternalList: utils.storeFromArea(state, ProfileActions.USER_PROFILE_SUBJEKT_EXTERNAL_LIST_AREA),
    };
}

export default withLang(connect(mapStateToProps)(ProfilePage));
